/**
 * @generated SignedSource<<a02566e490f23b1cd5b9f2448c85e395>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorePackageAuth_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club: {
        readonly id: string;
        readonly logoImage: {
          readonly publicId: string;
        } | null | undefined;
        readonly name: string;
        readonly slug: string;
        readonly supportsPublic: boolean;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "StorePackageAuth_session";
};
export type StorePackageAuth_session$key = {
  readonly " $data"?: StorePackageAuth_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorePackageAuth_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorePackageAuth_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supportsPublic",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Image",
                  "kind": "LinkedField",
                  "name": "logoImage",
                  "plural": false,
                  "selections": [
                    {
                      "alias": "publicId",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "renderingKey",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "4b30ac2dd871806a07ad1244fb90eb79";

export default node;
